import { useEffect, useState } from "react";
import type { FunctionComponent } from "react";
import { DeliveryStatus } from "@/pos/OrderType.ts";
import { useSignal } from "@/react/core/reactive.ts";
import {
  filtersDelivery,
  setFiltersDelivery,
  setFilterV
} from "@/react/DeliveryManagementView/DeliveryManagementLogic.tsx";
import { LL0 } from "@/react/core/I18nService.tsx";
import _ from "lodash";

interface StatusFilterProps {
  onClose?: () => void;
}

const StatusFilter: FunctionComponent<StatusFilterProps> = ({ onClose }) => {
  const [selectedStatuses, setSelectedStatuses] = useSignal<DeliveryStatus[]>([]);
  useEffect(() => {
    if (filtersDelivery()?.statuses) {
      setSelectedStatuses(filtersDelivery()?.statuses)
    }
  }, []);
  const handleCheckboxChange = (status: DeliveryStatus) => {
    setSelectedStatuses((prev) => {
      const newStatuses = prev.includes(status)
        ? prev.filter((s) => s !== status)
        : [...prev, status];
      console.log("Selected statuses:", newStatuses);
      return newStatuses;
    });
    const currentFilters = filtersDelivery();
    currentFilters.statuses = selectedStatuses()
    setFiltersDelivery(currentFilters);
    setFilterV(p => p + 1)
  };

  return (
    <div className="w-[524px] h-auto font-mulish overflow-hidden rounded-[8px] bg-white">
      <div className="flex flex-1 px-3 py-2 rounded-t-[8px] border-b border-[#e0e0e0]">
        <div className="flex-1 font-bold text-[16px] text-[#0051c1]">{LL0().orderHistory.filter()}</div>
        <img
          src="/icon-close-popup-icon--grey@2x.png"
          className="w-[22px] h-[22px]"
          alt=""
          onClick={onClose}
        />
      </div>
      <div className="flex flex-col gap-2 p-3">
        {Object.values(DeliveryStatus).map((status) => (
          <label key={status} className="relative gap-2 flex items-center p-2 rounded-[4px] border border-[#bcbcbc]">
            <input
              type="checkbox"
              className="z-[2] w-4 h-4 peer"
              checked={selectedStatuses().includes(status)}
              onChange={() => handleCheckboxChange(status)}
            />
            <div className="z-[1] absolute top-0 right-0 bottom-0 left-0 hidden peer-checked:flex peer-checked:bg-[#e3f2fd] peer-checked:border peer-checked:border-[#90caf9]" />
            <span
              className="z-[2] text-[14px] md:text-[12px] font-bold">{_.get(LL0().delivery.deliveryStatus2, status)?.()}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default StatusFilter;